import { createSlice } from '@reduxjs/toolkit'
import paymentConfig from '/payment.yml';
import { promiseCallApi, fetchApi, GET_METHOD, POST_METHOD, REQUEST_STATUS, switchSnack, gmoErrorMsg } from '~/stores/tools/commons';
import { vercelEnv } from '/src/constants/enviroment'

const initialState = {
  token: null,
  brand: null,
  holderName: null,
  maskedCardNo: null,
  cardInfo: {},
}

export const gmoSlice = createSlice({
  name: 'gmo',
  initialState,
  reducers: {
    fetchToken: (state, action) => {
      return {
        ...state,
        token: action.payload.token,
        brand: action.payload.brand,
        holderName: action.payload.holderName,
        maskedCardNo: action.payload.maskedCardNo
      }
    },
    searchRegisteredCard: (state, action) => {
      return {
        ...state,
        cardInfo: action.payload,
      }
    },
  },
})

export const { fetchToken, searchRegisteredCard } = gmoSlice.actions
export default gmoSlice.reducer

// GMOトークンの取得
export const getGmoToken = async (values, dispatch) => {
  // クレジットエラーハンドリング
  const gmoResponseHandler = response => {
    if (response.resultCode != "000") {
      // 登録失敗
      gmoErrorMsg(response.resultCode);
    }
    // 登録成功
    dispatch(fetchToken({
      token: response.tokenObject.token,
      brand: values.issuer.toUpperCase(),
      holderName: values.holdername.toUpperCase(),
      maskedCardNo: response.tokenObject.maskedCardNo,
    }))
    // ミールタイム はここでは登録しない予定(するなら以下のメソッドを実装していく)
    // dispatch(registereGmoCard(response.tokenObject.token, values.issuer));
  }

  window.gmoResponseHandler = gmoResponseHandler;
  // gmoTokenUrl[`${process.env.NEXT_PUBLIC_ENVIROMENT}`]
  const multipayment = () => {
    Multipayment.init(paymentConfig[vercelEnv[`${process.env.NEXT_PUBLIC_ENVIROMENT}`]]['gmo-pg']['shop_id']);
    Multipayment.getToken({
      cardno: values.cardno.replace(/\s+/g, ""),
      expire: `${values.expire.slice(3, 5)}${values.expire.slice(0, 2)}`,
      securitycode: values.cvc,
      holdername: values.holdername,
      tokennumber: values.tokennumber || 1
    }, "gmoResponseHandler");
    return new Promise(resolve => {
      resolve('success');
    });
  }
  const result = await multipayment();
}

// クレジットカードの検索
export const searchCard = (customer_id) => {
  return (async dispatch => {
    // api/v1/faqs
    const params = {id: customer_id}
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/gmos/search_card`;
    const response = await promiseCallApi(url, GET_METHOD, params);
    // const response = await fetchApi(url, params)
    if(response.status === REQUEST_STATUS.OK && !response.data.error) {
      dispatch(searchRegisteredCard(response.data.result));
    }
  })
}

